import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterOrderStatus'
})
export class FilterOrderStatusPipe implements PipeTransform {

  transform(lead): unknown {
    let orderStatuses = [];

    // Push Statuses Based on Conditions
    orderStatuses.push({name: 'New Order',         value: -1,        color:'validBox' });
    orderStatuses.push({name: 'Awaiting Feedback', value: 1,         color:'validBox' });
    orderStatuses.push({name: 'In Process',        value: 2,         color:'validBox' });

    // Only For Fully Paid
    if(lead.half_price == 0)
      orderStatuses.push({name: 'Completed', value: 3, color:'validBox' });

    // Only For Completed Orders
    if(lead.status == 3)
      orderStatuses.push({name: 'Mark Revision', value: 4, color:'validBox' });

    orderStatuses.push({name: 'Disputed', value: 5, color:'underReviewBox' });

    // Only For Half Priced
    if(lead.half_price == 1)
      orderStatuses.push({name: 'CWHP', value: 6, color:'underReviewBox' });

    orderStatuses.push({name: 'Refunded',          value: 7,         color:'invalidBox' });
    orderStatuses.push({name: 'Credited 0%',       value: "8-0",     percent: 0,        });
    orderStatuses.push({name: 'Credited 20%',      value: "8-20",    percent: 20,       });
    orderStatuses.push({name: 'Credited 50%',      value: "8-50",    percent: 50,       });
    orderStatuses.push({name: 'Credited 70%',      value: "8-75",    percent: 75,       });
    orderStatuses.push({name: 'Credited 100%',     value: "8-100",   percent: 100,      });

    return orderStatuses;
  }

}
